import { render, staticRenderFns } from "./TagViewPage.vue?vue&type=template&id=c4e50528&scoped=true&"
import script from "./TagViewPage.vue?vue&type=script&lang=js&"
export * from "./TagViewPage.vue?vue&type=script&lang=js&"
import style0 from "./TagViewPage.vue?vue&type=style&index=0&id=c4e50528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e50528",
  null
  
)

export default component.exports